(() => {
  const script = document.currentScript;
  const productPage = script && script.dataset.coloriaProduct === 'true';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let lastSelection = '';
  let lastCart = '';
  const fingerprint = cart => JSON.stringify(cart.items.filter(item => item.final_line_price > 0).map(item => [item.variant_id, item.quantity]).sort((a, b) => a[0] - b[0]));
  const readCart = async () => {
    const response = await fetch(root + 'cart.js', {cache: 'no-store'});
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };
  const selection = form => {
    const area = form.closest('[id^="ProductInfo-"]') || form.parentElement;
    return JSON.stringify({
      values: Array.from(new FormData(form).entries()).filter(([name]) => name === 'id' || name === 'quantity'),
      offers: Array.from(area.querySelectorAll('[role="radio"][aria-checked="true"], input[type="radio"]:checked')).map(el => el.textContent),
      options: Array.from(area.querySelectorAll('input[type="checkbox"]')).map(el => [el.name, el.value, el.checked]),
      selected: Array.from(area.querySelectorAll('[role="checkbox"]')).map(el => [el.textContent, el.getAttribute('aria-checked')])
    });
  };
  const drawerButton = () => document.querySelector('cart-drawer.active .es-popup-button-drawer');
  const openCartForm = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    const button = drawer?.querySelector('.es-popup-button-drawer');
    if (button) {
      button.click();
      return true;
    }
    return false;
  };
  if (productPage) {
    window.addEventListener('click', async event => {
      const button = event.target.closest?.('.es-popup-button-product');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const holder = button.closest('product-form');
      const form = holder?.querySelector('form');
      const add = holder?.querySelector('[id^="ProductSubmitButton-"]');
      if (!form || !add || add.disabled || add.getAttribute('aria-disabled') === 'true') return;
      busy = true;
      button.setAttribute('aria-busy', 'true');
      button.style.opacity = '0.65';
      let observer;
      let timer;
      let completed = false;
      const reset = () => {
        observer?.disconnect();
        clearTimeout(timer);
        busy = false;
        button.removeAttribute('aria-busy');
        button.style.opacity = '';
      };
      const fail = () => {
        reset();
        const error = holder.querySelector('.product-form__error-message');
        const wrapper = holder.querySelector('.product-form__error-message-wrapper');
        if (error && wrapper) {
          error.textContent = window.cartStrings?.error || window.variantStrings?.unavailable || '';
          wrapper.removeAttribute('hidden');
        }
      };
      try {
        const chosen = selection(form);
        const before = await readCart();
        if (chosen === lastSelection && fingerprint(before) === lastCart && openCartForm()) {
          reset();
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) throw new Error('Cart drawer unavailable');
        const finish = async () => {
          if (completed || !drawer.classList.contains('active') || add.disabled || !drawerButton()) return;
          completed = true;
          observer.disconnect();
          try {
            const after = await readCart();
            if (fingerprint(after) === fingerprint(before)) throw new Error('Bundle not added');
            lastSelection = selection(form);
            lastCart = fingerprint(after);
            if (!openCartForm()) throw new Error('COD button unavailable');
            reset();
          } catch (error) { fail(); }
        };
        observer = new MutationObserver(() => { void finish(); });
        observer.observe(drawer, {childList: true, subtree: true, attributes: true});
        observer.observe(add, {attributes: true});
        timer = setTimeout(fail, 20000);
        add.click();
      } catch (error) { fail(); }
    }, true);
  }
})();